<template>
  <b-input-group class="flex-nowrap">
    <Multiselect
      v-model="value"
      :placeholder="placeholder"
      multiple
      label="name"
      track-by="name"
      :hide-selected="true"
      :options="items"
      :show-labels="false"
      @input="itemsChanged"
    />
  </b-input-group>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'TagsComponent',

  components: {
    Multiselect,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    value: [],
  }),
  watch: {
    selectedItems(items) {
      this.value = items;
    }
  },
  methods: {
    itemsChanged () {
      this.$emit('itemsChanged', this.value)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .multiselect {
  min-height: 38px;
  
  &__placeholder {
    margin-bottom: 0;
  }
  
  &__select {
    &::before {
      color: #5e5e5e;
      border-color: #5e5e5e transparent transparent;
    }
  }

  &__tags {
    min-height: 50px;
    max-height: 180px;
    overflow-y: auto;
    padding: 15px 40px 15px 15px;
  }
  
  &__tag {
    font-weight: 500;
    background: #007964;
    padding: 5px 26px 6px 10px;
    
    &-icon {
      &::after {
        color: #fff;
      }
    }
  }

  &__placeholder {
    font-size: 1rem;
    font-weight: 400;
    padding: 0;
  }
}
</style>
